import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';

const styles = theme => ({
  card: {
    //margin:10,
    textAlign:'center',
    marginBottom:'10px',
    [theme.breakpoints.down('sm')]: {
      minHeight: '70px',
      height: '70px',
    },
  },
  cardHeader: {
    fontFamily: 'Flanders Art Sans!important',
    backgroundColor: '#f3f3f3',
    color: '#fff',
    textAlign: 'left',
    height: '100%',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      padding:'0!important',
    },
  },
  cardHeaderLink: {
    fontFamily: 'Flanders Art Sans!important',
    backgroundColor: '#f3f3f3',
    color: '#fff!important',
    textAlign: 'left',
    '&:hover': {
      color: '#bbb!important',
    },
    fontWeight: '400!important',
  }
});

function Mainsite(props) {
  const { classes } = props;

  let stats='Naar de stroomvoorspeller'
/*
  switch (props.lang) {
    case "de":
      faq = 'Haufig gestellte Fragen'
      break;
    case "en":
      faq = 'Frequently Asked Questions'
      break;
    case "fr":
      faq = 'Foire aux questions'
      break;
    case 'nl':
    default:
      faq = 'Naar de veelgestelde vragen'
  }
*/
  return (
    <Card className={classes.card}>
      <a
        target="_blank"
        style={{ fontWeight: 400 }}
        // Using target="_blank" without rel="noopener noreferrer" is a security risk: see https://mathiasbynens.github.io/rel-noopener  react/jsx-no-target-blank
        rel="noopener noreferrer"
        href="https://apps.energiesparen.be/stroomvoorspeller">
        <CardHeader
          className={classes.cardHeader + ' bgdarkbluegreen' }
          disableTypography
          title={stats}
        />
      </a>
    </Card>
  );
}

Mainsite.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Mainsite);